<template>
    <flat-pickr
v-model="internalValue" :class="['form-control', { 'is-invalid': hasError }]" :config="config"
        v-bind="$attrs" />
    <div v-if="hasError" class="invalid-feedback">
        {{ errors[errorFieldName][0] }}
    </div>
</template>

<script setup>
import { ref, watch, computed } from 'vue';
import FlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { Spanish } from 'flatpickr/dist/l10n/es.js';

const props = defineProps({
    modelValue: {
        type: [String, Number, Date, Array, null],
        default: null
    },
    errors: {
        type: Object,
        default: () => ({})
    },
    errorFieldName: {
        type: String,
        required: true
    },
    isAllDay: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['update:modelValue']);
const internalValue = ref(props.modelValue);

watch(() => props.modelValue, (newValue) => {
    internalValue.value = newValue;
});

watch(internalValue, (newValue) => {
    emit('update:modelValue', newValue);
});

const hasError = computed(() => {
    return props.errors && props.errors[props.errorFieldName];
});

const config = computed(() => ({
    enableTime: !props.isAllDay,
    time_24hr: false,
    altFormat: props.isAllDay ? 'F j, Y' : 'F j, Y h:i K',
    altInput: true,
    dateFormat: props.isAllDay ? 'Y-m-d' : 'Y-m-d H:i:S',
    locale: Spanish,
    allowInput: true,
}));
</script>

<style scoped>
.is-invalid {
    border-color: #dc3545;
}

.invalid-feedback {
    display: block;
    color: #dc3545;
}
</style>
